<template>
  <div>
    <slot v-if="!hasError" />
    <div v-else class="error-message">
      <p>Something went wrong. Please try again later.</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasError: false,
    };
  },
  errorCaptured(err, vm, info) {
    console.error("Error captured in component:", { err, vm, info });
    this.hasError = true;
    return false; // Prevents the error from propagating further
  },
};
</script>

<style scoped>
.error-message {
  color: red;
  text-align: center;
}
</style>
